export const SQUEEZING = 'squeezing'
